<template>
  <div>
    <el-card shadow="never" class="w1200">
      <div class="article">
          <div v-if="special=='MTA0'" class="header" >
            <h3>实验内容</h3>
            <span>Experimental content</span>
          </div>
          <div v-else class="header" >
            <h3>实验项目特色</h3>
            <span>Characteristics of Experimental Projects</span>
          </div>
        <Article v-html="article"></Article>
      </div>
    </el-card>
  </div>
</template>

<script>
import Article from "@/components/Article";

import { getArticle } from "@/api/views/character";

export default {
  name: "Character",
  components: {
    Article
  },
  data() {
    return {
      header: "实验项目特色",
      article: "",
      // 是否是西安电子科技大学专门定做的页面（url的School_id参数为'MTA0'时）
      special : this.$route.query.School_id
    };
  },
  created() {
    getArticle(this.$route.query.School_id).then(res => {
      this.article = res.data.characteristics;
    });
  }
};
</script>

<style lang="scss" scoped>
.header {
  text-align: left;

  h3 {
    margin-bottom: 0px;
  }

  span {
    font-size: 13px;
  }
}
.article {
  padding: 35px 150px;
  text-align: left;
}
</style>
